import { styled } from '@mui/material/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableSortLabel,
} from '@mui/material';

// Styled components following strikingDash design
export const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: '10px',
  boxShadow: '0 10px 30px rgba(146,153,184,0.15)',
  border: 'none',
  '& .MuiTable-root': {
    minWidth: 650,
  },
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: '#F4F5F7',
  position: 'sticky',
  top: 0,
  zIndex: 10,
  '& .MuiTableCell-head': {
    fontWeight: 600,
    fontSize: '12px',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    padding: '16px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    whiteSpace: 'nowrap',
  },
}));

export const StyledTableBody = styled(TableBody)(({ theme }) => ({
  '& .MuiTableRow-root': {
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '& .MuiTableCell-body': {
      fontSize: '14px',
      padding: '12px 16px',
      borderBottom: `1px solid ${theme.palette.divider}`,
      // Don't set default color here - let inline styles override
    },
    // Nested/Detail rows styling
    '&.nested-row': {
      backgroundColor: '#F8F9FA',
      '&:hover': {
        backgroundColor: '#F1F3F4',
      },
      '& .MuiTableCell-body': {
        fontSize: '13px',
      },
    },
  },
}));

export const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  '& .MuiTablePagination-toolbar': {
    padding: '16px',
  },
  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    fontSize: '14px',
    color: theme.palette.text.secondary,
  },
  '& .MuiTablePagination-select': {
    borderRadius: '6px',
    border: `1px solid ${theme.palette.divider}`,
    padding: '6px 32px 6px 12px',
    fontSize: '14px',
  },
  '& .MuiIconButton-root': {
    borderRadius: '6px',
    border: `1px solid ${theme.palette.divider}`,
    margin: '0 4px',
    padding: '6px',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: `${theme.palette.primary.main}10`,
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
    },
    '&.Mui-disabled': {
      borderColor: theme.palette.divider,
      opacity: 0.5,
    },
  },
}));

export const StyledTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
  '&.MuiTableSortLabel-root': {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main,
    },
    '&.Mui-active': {
      color: theme.palette.primary.main,
      '& .MuiTableSortLabel-icon': {
        color: theme.palette.primary.main,
      },
    },
  },
}));

export {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableSortLabel,
};
